import { render, staticRenderFns } from "./qlxxTfDialog.vue?vue&type=template&id=488c1c93&scoped=true"
import script from "./qlxxTfDialog.vue?vue&type=script&lang=js"
export * from "./qlxxTfDialog.vue?vue&type=script&lang=js"
import style0 from "./qlxxTfDialog.vue?vue&type=style&index=0&id=488c1c93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488c1c93",
  null
  
)

export default component.exports